import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { config, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import io from 'socket.io-client';
import { format } from "date-fns";

const OpportunityEditBant = () => {
  const { id_opportunity } = useParams();
  const [ opportunityData, setOpportunityData ] = useState(null);
  const [ opportunityDealType, setOpportunityDealType ] = useState(null);
  const [ opportunityProductLine, setOpportunityProductLine ] = useState(null);
  const [ opportunityProductDetail, setOpportunityProductDetail ] = useState('');
  const [ opportunityProductMonths, setOpportunityProductMonths ] = useState(0);
  const [ opportunityExpectedClosed, setOpportunityExpectedClosed ] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [ opportunityExpectedRevenue, setOpportunityExpectedRevenue ] = useState(0);
  const [ opportunityExpectedProfit, setOpportunityExpectedProfit ] = useState(0);
  const [ opportunityRemarks, setOpportunityRemarks ] = useState('');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const dealTypeOptions = [
    { value: 'New Business', label: 'New Business' },
    { value: 'Cross Selling', label: 'Cross Selling' },
    { value: 'Exist Additional', label: 'Exist Additional' },
    { value: 'Renew Only', label: 'Renew Only' },
    { value: 'Upgrade', label: 'Upgrade' },
  ];

  const productLineOptions = [
    { label: 'GWS SMB', value: 'GWS SMB' },
    { label: 'GWS CORP', value: 'GWS CORP' },
    { label: 'GWS ENTERPRISE', value: 'GWS ENTERPRISE' },
    { label: 'CHROME ENTERPRISE', value: 'CHROME ENTERPRISE' },
    { label: 'CHROME EDUCATION', value: 'CHROME EDUCATION' },
    { label: 'HARDWARE', value: 'HARDWARE' },
    { label: 'EDUCATION LICENSES', value: 'EDUCATION LICENSES' },
    { label: 'TRAINING', value: 'TRAINING' },
    { label: 'SERVICES', value: 'SERVICES' },
    { label: 'MICROSOFT', value: 'MICROSOFT' },
    { label: 'GOOGLE CLOUD', value: 'GOOGLE CLOUD' },
    { label: 'GEMINI ENTERPRISE', value: 'GEMINI ENTERPRISE' },
    { label: 'APIGEE', value: 'APIGEE' },
    { label: 'LUMAPPS', value: 'LUMAPPS' },
    { label: 'JUMPCLOUD', value: 'JUMPCLOUD' },
    { label: 'OTHER LICENSES', value: 'OTHER LICENSES' },
    { label: 'CUSTOM APPS', value: 'CUSTOM APPS' },
    { label: 'KAMIGAWE LICENSES', value: 'KAMIGAWE LICENSES' },
    { label: 'KAMIGAWE SERVICES', value: 'KAMIGAWE SERVICES' },
    { label: 'SAAS APPS (ALBAN)', value: 'SAAS APPS (ALBAN)' }
  ];

  useEffect(() => {
    const getOpportunityData = async () => {
      try {
        const fetchOpportunity = await jwtFetch(config.ENDPOINT + 'get/opportunity', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "id_opportunity": id_opportunity
          })
        });
        const responseOpportunity = await fetchOpportunity.json();
        if (responseOpportunity.status === 200) {
          const opportunity = responseOpportunity.data[0];
          setOpportunityData(opportunity);
          console.log(opportunity);
          setOpportunityDealType({ value: opportunity.opportunity_deal_type || '', label: opportunity.opportunity_deal_type || '' });
          setOpportunityProductLine({ value: opportunity.opportunity_product_line || '', label: opportunity.opportunity_product_line || '' });
          setOpportunityProductDetail(opportunity.opportunity_product_detail || '');
          setOpportunityProductMonths(opportunity.opportunity_product_months || 0);
          setOpportunityExpectedClosed(format(new Date(opportunity.opportunity_expected_closed || ''), 'yyyy-MM-dd'));
          setOpportunityExpectedRevenue(opportunity.opportunity_expected_revenue || 0);
          setOpportunityExpectedProfit(opportunity.opportunity_expected_profit || 0);
          setOpportunityRemarks(opportunity.opportunity_remarks || '');
        } else {
          console.log(responseOpportunity.message);
        }
      } catch (error) {
        console.error('Error in getOpportunityData:', error);
        alert('An error occurred: ' + (error.message || error));
      }
    };    
    getOpportunityData();
  }, [id_opportunity]);

  const updateOpportunity = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      const requestOpportunityUpdate = {
        "id_opportunity": id_opportunity,
        "opportunity_deal_type": opportunityDealType.value,
        "opportunity_product_line": opportunityProductLine.value,
        "opportunity_product_detail": opportunityProductDetail,
        "opportunity_product_months": opportunityProductMonths,
        "opportunity_expected_closed": opportunityExpectedClosed,
        "opportunity_expected_revenue": opportunityExpectedRevenue,
        "opportunity_expected_profit": opportunityExpectedProfit,
        "opportunity_remarks": opportunityRemarks,
        "updated_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "updated_by": crmUser.user_keyid,
      }

      const fetchOpportunityUpdate = await jwtFetch(config.ENDPOINT + 'update/opportunity', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOpportunityUpdate)
      });
      const responseOpportunityUpdate = await fetchOpportunityUpdate.json();
      if (responseOpportunityUpdate.status === 200) {
        window.location.href = '/opportunity/detail/' + id_opportunity;
      } else {
        console.log(responseOpportunityUpdate.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in updateOpportunity:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="opportunity-detail-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="lead"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <a className="text-secondary" href="/opportunity">Opportunity List</a>
                    <span className="mx-3"><i className="bi bi-chevron-right"/></span>
                    <span>Opportunity Edit</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="fs-24">Detail Edit</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-12">
                      <form className="bg-white border-radius-4 p-4" onSubmit={(e) => updateOpportunity(e)} id="submit-form">
                        <div className="border border-1 border-radius-3 p-4 mb-3">
                          <div className="row mb-4">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <div className="fs-24">Details</div>
                            </div>
                            <div className="col-md-6">
                              <div className="row align-items-baseline form-group mb-2">
                                <div className="col-md-4">
                                  <label>Product Line <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={productLineOptions} value={opportunityProductLine} onChange={(value) => setOpportunityProductLine(value)} />
                                </div>
                              </div>
                              <div className="row align-items-baseline form-group mb-2">
                                <div className="col-md-4">
                                  <label>Product Details <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <textarea className="form-control" rows="4" value={opportunityProductDetail} onChange={(e) => setOpportunityProductDetail(e.target.value)} />
                                </div>
                              </div>
                              <div className="row align-items-baseline form-group mb-2">
                                <div className="col-md-4">
                                  <label>Deal Type <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={dealTypeOptions} value={opportunityDealType} onChange={(value) => setOpportunityDealType(value)} />
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Remarks</label>
                                </div>
                                <div className="col-md-8">
                                  <textarea className="form-control" rows="4" value={opportunityRemarks} onChange={(e) => setOpportunityRemarks(e.target.value)} />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="card mb-2">
                                <div className="card-body">
                                  <div className="row form-group align-items-center mb-2">
                                    <div className="col-md-4">
                                      <label>Months <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-8">
                                      <input className="form-control text-end" type="number" value={opportunityProductMonths} onChange={(e) => setOpportunityProductMonths(numberFormat(e.target.value))}/>
                                    </div>
                                  </div>
                                  <div className="row form-group align-items-center">
                                    <div className="col-md-4">
                                      <label>Expected Closing Date <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-8">
                                      <input className="form-control" type="date" value={opportunityExpectedClosed} onChange={(e) => setOpportunityExpectedClosed(e.target.value)}/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card mb-2">
                                <div className="card-body">
                                  <div className="row form-group align-items-center mb-2">
                                    <div className="col-md-4">
                                      <label>Estimated Revenue <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-8">
                                      <div className="input-group">
                                        <input className="form-control text-end" type="text" value={priceFormat(opportunityExpectedRevenue)} onChange={(e) => setOpportunityExpectedRevenue(numberFormat(e.target.value))}/>
                                        <span className="input-group-text mw-85">IDR</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row form-group align-items-center">
                                    <div className="col-md-4">
                                      <label>Estimated Profit <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-8">
                                      <div className="input-group">
                                        <input className="form-control text-end" type="text" value={priceFormat(opportunityExpectedProfit)} onChange={(e) => setOpportunityExpectedProfit(numberFormat(e.target.value))}/>
                                        <span className="input-group-text mw-85">IDR</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-link" type="button" onClick={() => window.location.href = `/opportunity/detail/${id_opportunity}`}>Cancel</button>
                          <button className="btn bg-gold ms-2" type="submit">{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                        </div>
                      </form>
                    </div>                    
                  </div>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpportunityEditBant;


